<template>
    <EditDialog title="接口授权" :show="visible" width="800px">
        <div style="color: red; padding: 0 10px">注：次数限制填写零时为不限制次数。</div>
        <div class="interface">
            <template v-if="sysMgr.length">
                <h4>管理类接口</h4>
                <el-table ref="sysMgr" size="mini" :data="sysMgr" style="width: 100%">
                    <el-table-column width="55" label="启用">
                        <template #default="{ row }">
                            <el-checkbox v-model="row.Enabled"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column prop="InterfaceName" label="名称"> </el-table-column>
                    <el-table-column prop="MaxTimes" label="总调用次数限制">
                        <template #default="{ row }">
                            <el-input-number :precision="0" size="mini" v-model="row.MaxTimes" :min="0"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="DayMaxTimes" label="单日最大调用次数">
                        <template #default="{ row }">
                            <el-input-number :precision="0" size="mini" v-model="row.DayMaxTimes" :min="0"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="MinInterval" label="最小调用间隔">
                        <template #default="{ row }">
                            <el-input-number :precision="0" size="mini" v-model="row.MinInterval" :min="0"></el-input-number>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template v-if="baseData.length">
                <h4>系统数据获取</h4>
                <el-table ref="baseData" size="mini" :data="baseData" style="width: 100%">
                    <el-table-column width="55" label="启用">
                        <template #default="{ row }">
                            <el-checkbox v-model="row.Enabled"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column prop="InterfaceName" label="名称"> </el-table-column>
                    <el-table-column prop="MaxTimes" label="总调用次数限制">
                        <template #default="{ row }">
                            <el-input-number :precision="0" size="mini" v-model="row.MaxTimes" :min="0"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="DayMaxTimes" label="单日最大调用次数">
                        <template #default="{ row }">
                            <el-input-number :precision="0" size="mini" v-model="row.DayMaxTimes" :min="0"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="MinInterval" label="最小调用间隔">
                        <template #default="{ row }">
                            <el-input-number :precision="0" size="mini" v-model="row.MinInterval" :min="0"></el-input-number>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template v-if="flow.length">
                <h4>客流数据类型接口</h4>
                <el-table ref="flow" size="mini" :data="flow" style="width: 100%">
                    <el-table-column width="55" label="启用">
                        <template #default="{ row }">
                            <el-checkbox v-model="row.Enabled"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column prop="InterfaceName" label="名称"> </el-table-column>
                    <el-table-column prop="MaxTimes" label="总调用次数限制">
                        <template #default="{ row }">
                            <el-input-number :precision="0" size="mini" v-model="row.MaxTimes" :min="0"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="DayMaxTimes" label="单日最大调用次数">
                        <template #default="{ row }">
                            <el-input-number :precision="0" size="mini" v-model="row.DayMaxTimes" :min="0"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="MinInterval" label="最小调用间隔">
                        <template #default="{ row }">
                            <el-input-number :precision="0" size="mini" v-model="row.MinInterval" :min="0"></el-input-number>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template v-if="operate.length">
                <h4>营业数据类接口</h4>
                <el-table ref="operate" size="mini" :data="operate" style="width: 100%">
                    <el-table-column width="55" label="启用">
                        <template #default="{ row }">
                            <el-checkbox v-model="row.Enabled"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column prop="InterfaceName" label="名称"> </el-table-column>
                    <el-table-column prop="MaxTimes" label="总调用次数限制">
                        <template #default="{ row }">
                            <el-input-number :precision="0" size="mini" v-model="row.MaxTimes" :min="0"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="DayMaxTimes" label="单日最大调用次数">
                        <template #default="{ row }">
                            <el-input-number :precision="0" size="mini" v-model="row.DayMaxTimes" :min="0"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="MinInterval" label="最小调用间隔">
                        <template #default="{ row }">
                            <el-input-number :precision="0" size="mini" v-model="row.MinInterval" :min="0"></el-input-number>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </div>
        <template #button>
            <div class="dialog-footer">
                <el-button size="mini" @click="handleSave" style="margin-right: 30px" type="primary">保存</el-button>
                <el-button size="mini" @click="handleCancel">取消</el-button>
            </div>
        </template>
    </EditDialog>
</template>

<script>
export default {
    name: "InterfaceAuth",
    props: {
        visible: {
            type: Boolean,
        },
        app: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {
            sysMgr: [], //管理类
            baseData: [], //系统数据
            flow: [], //客流数据
            operate: [], //营业数据
        };
    },
    methods: {
        getData() {
            this.$ajax.post("/Platform/GetAppInterfaces?ak=" + this.app.AppAK).then((res) => {
                if (res.Data) {
                    let tableData = res.Data;
                    this.sysMgr = tableData.filter((item) => item.InterfaceType === 1);
                    this.baseData = tableData.filter((item) => item.InterfaceType === 2);
                    this.flow = tableData.filter((item) => item.InterfaceType === 3);
                    this.operate = tableData.filter((item) => item.InterfaceType === 4);
                }
            });
        },
        handleSave() {
            let params = [...this.sysMgr, ...this.baseData, ...this.flow, ...this.operate];
            this.$ajax.post("/Platform/SaveAppInterfaces?ak=" + this.app.AppAK, params).then((res) => {
                this.$success("操作成功");
                this.$emit("refresh", true);
                this.handleCancel();
            });
        },
        handleCancel() {
            this.$emit("update:visible", false);
        },
    },
    created() {
        this.getData();
    },
};
</script>

<style scoped>
.dialog-footer {
    margin-top: 10px;
}
</style>
